<div class="w-full">
    <div class="flex justify-between border-b border-b-gray-300 zuper-dialog-header">
        <h6 mat-dialog-title class="font-semibold primary-font">{{data?.data?.title}}</h6>
    </div>
    <div class="view-history-dialog p-6">
        <input 
                [matDatepicker]="routeDatePicker"
                type="text" 
                name="searchDate"
                id="searchDate"  
                [(ngModel)]="searchDate"
                class="mt-1 mb-2 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-white px-3 py-3 leading-none text-base cursor-pointer"
                [placeholder]="_utilityService.getLocaleValue('input.placeholder.pick_date')"
                (click)="routeDatePicker.open()"
                value=""
                [max]="today"
                [datePickerFormat]="dateFormat"
                readonly
        >     
        <mat-datepicker [dateClass]="dateClass"  #routeDatePicker ></mat-datepicker>
    </div>
    <div mat-dialog-actions class="flex justify-end space-x-3 border-t border-gray-300 zuper-dialog-footer">
        <button mat-stroked-button mat-dialog-close class="px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white btn-small hover:bg-gray-50 focus:outline-none" type="button">{{'reports.scheduled_reports.dialog.button.cancel' | translate}}</button>
        <button (click)="selectDate()" class="bg-primary px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-white font-medium rounded-md text-white-600 btn-small focus:outline-none" type="submit">{{'maps.button.show_history' | translate}}</button>
    </div>
</div>